module.exports = ".image-link-wrapper {\n  margin-top: 40px;\n}\n"